import { ERROR_CODE, ERROR_TEXTS_BY_CODE } from '@config/errors';

import {
  BaseNetBodyOtherErrorDto,
  BaseNetErrorAuthBodyDto,
  BaseNetErrorBodyDto,
  BaseNetErrorBodyFieldErrorDto,
} from '@services/dto/errors/base-net-error';

export const isBaseNetErrorAuthBody = (
  data: unknown
): data is BaseNetErrorAuthBodyDto => {
  return Boolean((data as { error?: unknown })?.error);
};

export const isBaseNetErrorBody = (
  data: unknown //
): data is BaseNetErrorBodyDto => {
  return Boolean((data as { errors?: unknown })?.errors);
};

export const isBaseNetErrorBodyFieldError = (
  error: BaseNetErrorBodyFieldErrorDto | BaseNetBodyOtherErrorDto
): error is BaseNetErrorBodyFieldErrorDto => {
  return Boolean(error.data?.field);
};

export const defineAuthErrorCode = (message: string): ERROR_CODE => {
  switch (message) {
    case ERROR_CODE.INCORRECT_USERNAME_OR_PASSWORD:
      return ERROR_CODE.INCORRECT_USERNAME_OR_PASSWORD;
    default:
      return ERROR_CODE.UNEXPECTED_ERROR;
  }
};

export const getMessageTextByCode = (code: ERROR_CODE): string => {
  if (code in ERROR_TEXTS_BY_CODE) {
    return ERROR_TEXTS_BY_CODE[code as keyof typeof ERROR_TEXTS_BY_CODE];
  }

  return ERROR_TEXTS_BY_CODE[ERROR_CODE.UNEXPECTED_ERROR];
};
